(function () {
  "use strict";

  function initFinder(root) {
    if (!root || root.dataset.arfReady === "true") return;

    var data;
    try {
      data = JSON.parse(root.querySelector("[data-arf-data]").textContent);
    } catch (error) {
      return;
    }

    var models = Array.isArray(data.models) ? data.models : [];
    var settings = data.settings || {};
    var links = settings.links || {};
    var catalogReviewEntries = Array.isArray(settings.catalogReview) ? settings.catalogReview : [];
    var form = root.querySelector("[data-arf-form]");
    var workspace = root.querySelector("[data-arf-workspace]");
    var steps = Array.prototype.slice.call(root.querySelectorAll("[data-step]"));
    var progress = root.querySelector("[data-progress-bar]");
    var progressLabel = root.querySelector("[data-progress-label]");
    var progressName = root.querySelector("[data-progress-name]");
    var stepButtons = Array.prototype.slice.call(root.querySelectorAll("[data-jump-step]"));
    var nextButton = root.querySelector("[data-next]");
    var backButton = root.querySelector("[data-back]");
    var resetButton = root.querySelector("[data-reset]");
    var editButtons = Array.prototype.slice.call(root.querySelectorAll("[data-edit-answers]"));
    var status = root.querySelector("[data-status]");
    var loadInput = form ? form.querySelector("[name='totalLoad']") : null;
    var unitLabel = root.querySelector("[data-unit-label]");
    var unitButtons = Array.prototype.slice.call(root.querySelectorAll("[data-unit]"));
    var payloadNote = root.querySelector("[data-payload-note]");
    var resultStatus = root.querySelector("[data-result-status]");
    var results = root.querySelector("[data-results]");
    var noMatch = root.querySelector("[data-no-match]");
    var noMatchTitle = root.querySelector("[data-no-match-title]");
    var primaryResult = root.querySelector("[data-primary-result]");
    var resultImage = root.querySelector("[data-result-image]");
    var resultImagePlaceholder = resultImage ? resultImage.getAttribute("src") : "";
    var alternativesSection = root.querySelector("[data-alternatives-section]");
    var alternatives = root.querySelector("[data-alternatives]");
    var alternativeCount = root.querySelector("[data-alternative-count]");
    var catalogReview = root.querySelector("[data-catalog-review]");
    var catalogReviewCopy = root.querySelector("[data-catalog-review-copy]");
    var copyButton = root.querySelector("[data-copy-link]");
    var finalCta = root.querySelector("[data-final-cta]");
    var finalResultCta = root.querySelector("[data-final-result-cta]");
    var reducedMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var stepNames = ["Age & route", "Ride format", "Typical ride", "Load & price"];
    var state = {
      step: 1,
      reached: 1,
      unit: settings.defaultUnit === "metric" ? "metric" : "us",
      loadLb: 0,
      ranked: [],
      answers: null
    };

    if (!form || !workspace || steps.length !== 4 || !results || !loadInput || !nextButton || !backButton || !resetButton) return;

    root.dataset.arfReady = "true";
    root.classList.add("is-ready");

    function runTransition(update, className) {
      update();
      if (!className) return;
      root.classList.remove(className);
      void root.offsetWidth;
      root.classList.add(className);
      window.setTimeout(function () { root.classList.remove(className); }, 320);
    }

    function scrollToElement(element) {
      if (!element || typeof element.scrollIntoView !== "function") return;
      element.scrollIntoView({ behavior: reducedMotion ? "auto" : "smooth", block: "start" });
    }

    function keepStepHeadingVisible(element) {
      if (!element || typeof element.getBoundingClientRect !== "function") return;
      window.requestAnimationFrame(function () {
        var rect = element.getBoundingClientRect();
        var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
        var safeTop = window.innerWidth <= 760 ? 88 : 112;
        var safeBottom = Math.max(safeTop + 120, viewportHeight - 72);
        var adjustment = 0;
        if (rect.top < safeTop) adjustment = rect.top - safeTop;
        else if (rect.bottom > safeBottom) adjustment = rect.bottom - safeBottom;
        if (Math.abs(adjustment) < 2) return;
        window.scrollBy({ top: adjustment, left: 0, behavior: reducedMotion ? "auto" : "smooth" });
      });
    }

    function announce(message, tone) {
      if (!status) return;
      status.textContent = message || "";
      status.dataset.tone = tone || "";
    }

    function setActiveLane(value) {
      if (value === "private") root.dataset.activeLane = "ppb";
      else if (value === "public" || value === "unsure") root.dataset.activeLane = "class2";
      else delete root.dataset.activeLane;
    }

    function setStep(stepNumber, shouldFocus) {
      var nextStep = Math.max(1, Math.min(steps.length, Number(stepNumber) || 1));
      state.step = nextStep;
      state.reached = Math.max(state.reached, nextStep);

      runTransition(function () {
        steps.forEach(function (step) {
          step.hidden = Number(step.dataset.step) !== nextStep;
        });
        if (progress) {
          progress.value = nextStep;
          progress.max = steps.length;
          progress.textContent = "Step " + nextStep + " of " + steps.length;
          progress.setAttribute("aria-valuetext", stepNames[nextStep - 1] + ", step " + nextStep + " of " + steps.length);
        }
        if (progressLabel) progressLabel.textContent = "Step " + nextStep + " of " + steps.length;
        if (progressName) progressName.textContent = stepNames[nextStep - 1];
        stepButtons.forEach(function (button) {
          var buttonStep = Number(button.dataset.jumpStep);
          button.disabled = buttonStep > state.reached;
          if (buttonStep === nextStep) button.setAttribute("aria-current", "step");
          else button.removeAttribute("aria-current");
        });
        backButton.hidden = nextStep === 1;
        resetButton.hidden = nextStep === 1;
        nextButton.textContent = nextStep === steps.length ? "Show my best match" : "Continue";
        announce("");
      }, "is-transitioning");

      if (shouldFocus) {
        var heading = steps[nextStep - 1].querySelector("[data-step-heading]");
        if (heading) heading.focus({ preventScroll: true });
        keepStepHeadingVisible(heading);
      }
    }

    function selectedValue(name) {
      var checked = form.querySelector("[name='" + name + "']:checked");
      return checked ? checked.value : "";
    }

    function updateLoadFromInput() {
      var visibleValue = Number(loadInput.value || 0);
      state.loadLb = state.unit === "metric" ? visibleValue * 2.2046226218 : visibleValue;
      if (!payloadNote) return;
      if (!visibleValue) {
        payloadNote.textContent = "Every recommendation must clear this published payload rating.";
      } else if (state.loadLb > 400) {
        payloadNote.textContent = "That load is above the common 400 lb ceiling in the current catalog. A specialist may need to review the fit.";
      } else if (state.loadLb > 350) {
        payloadNote.textContent = "Only models with a published rating above " + Math.round(state.loadLb) + " lb will remain.";
      } else {
        payloadNote.textContent = "Models rated below " + Math.round(state.loadLb) + " lb will be removed before price and ride preferences are compared.";
      }
    }

    function setUnit(unit, convertVisible) {
      var nextUnit = unit === "metric" ? "metric" : "us";
      if (convertVisible && Number(loadInput.value || 0) > 0) updateLoadFromInput();
      state.unit = nextUnit;
      unitButtons.forEach(function (button) {
        button.setAttribute("aria-pressed", String(button.dataset.unit === nextUnit));
      });
      if (unitLabel) unitLabel.textContent = nextUnit === "metric" ? "kg" : "lb";
      loadInput.max = nextUnit === "metric" ? "272" : "600";
      if (convertVisible && state.loadLb > 0) {
        loadInput.value = nextUnit === "metric" ? String(Math.round(state.loadLb / 2.2046226218)) : String(Math.round(state.loadLb));
      }
      updateLoadFromInput();
    }

    function focusFirst(name) {
      var input = form.querySelector("[name='" + name + "']");
      if (input) input.focus();
    }

    function validateAge() {
      var age = selectedValue("riderAge");
      if (age !== "16-17" && age !== "18-plus") {
        announce(age === "under-16" ? "We cannot recommend a bike for an operator under 16. Ariel Rider e-bikes require age 16 or older; PPBs require age 18 or older." : "Choose the operator age range before continuing.", "error");
        focusFirst("riderAge");
        return false;
      }
      if (age !== "18-plus" && selectedValue("useArea") === "private") {
        announce("PPBs require an operator age of 18 or older, including when speed-limited. At age 16 or 17, choose the Class 2 e-bike path to compare eligible bikes.", "error");
        focusFirst("useArea");
        return false;
      }
      return true;
    }

    function validateStep() {
      if (!validateAge()) return false;
      if (state.step === 1 && !selectedValue("useArea")) {
        announce("Choose where you plan to ride before continuing.", "error");
        focusFirst("useArea");
        return false;
      }
      if (state.step === 2 && !selectedValue("rideFormat")) {
        announce("Choose a ride format, or let the trip and price decide.", "error");
        focusFirst("rideFormat");
        return false;
      }
      if (state.step === 3 && !selectedValue("terrain")) {
        announce("Choose your usual riding surface.", "error");
        focusFirst("terrain");
        return false;
      }
      if (state.step === 3 && !selectedValue("distance")) {
        announce("Choose your normal round-trip distance.", "error");
        focusFirst("distance");
        return false;
      }
      if (state.step === 4) {
        updateLoadFromInput();
        var visibleLoad = Number(loadInput.value || 0);
        var visibleMaximum = Number(loadInput.max || 0);
        if (!visibleLoad || state.loadLb <= 0) {
          announce("Enter the combined rider, passenger, and cargo weight.", "error");
          loadInput.focus();
          return false;
        }
        if (visibleMaximum > 0 && visibleLoad > visibleMaximum) {
          announce("Enter a total of " + visibleMaximum + " " + (state.unit === "metric" ? "kg" : "lb") + " or less, then ask support if you need a higher-capacity review.", "error");
          loadInput.focus();
          return false;
        }
        if (!selectedValue("budget")) {
          announce("Choose a price ceiling before seeing your match.", "error");
          focusFirst("budget");
          return false;
        }
      }
      return true;
    }

    function readAnswers() {
      updateLoadFromInput();
      return {
        riderAge: selectedValue("riderAge"),
        useArea: selectedValue("useArea"),
        rideFormat: selectedValue("rideFormat"),
        terrain: selectedValue("terrain"),
        distance: selectedValue("distance"),
        budget: selectedValue("budget"),
        loadLb: Math.round(state.loadLb)
      };
    }

    function budgetCeiling(value) {
      return {
        "under-2000": 2000,
        "2000-2500": 2500,
        "2500-3000": 3000,
        "flexible": Infinity
      }[value] || Infinity;
    }

    function distanceTarget(value) {
      return {
        "under-20": 20,
        "20-40": 40,
        "40-60": 60,
        "60-plus": 80
      }[value] || 40;
    }

    function numeric(value) {
      var parsed = Number(value);
      return Number.isFinite(parsed) ? parsed : 0;
    }

    function classificationFor(answers) {
      return answers.useArea === "private" ? "ppb" : "class2";
    }

    function availableLaneModels(answers) {
      var classification = classificationFor(answers);
      return models.filter(function (model) {
        return (answers.riderAge === "18-plus" || (answers.riderAge === "16-17" && classification === "class2")) && model.classification === classification && model.available === true;
      });
    }

    function scoreModel(model, answers, targetRange) {
      var score = 20;
      var power = numeric(model.powerScore);
      var comfort = numeric(model.comfortScore);
      var range = numeric(model.rangeScore);
      var value = numeric(model.valueScore);
      var torque = numeric(model.torqueNm);
      var payload = numeric(model.payloadLb);
      var minRange = numeric(model.rangeMin);
      var isMopedStyle = model.mopedStyle === true;

      if (answers.rideFormat === "upright") score += isMopedStyle ? -18 : 20;
      if (answers.rideFormat === "suspension") score += model.fullSuspension ? 20 : -14;
      if (answers.rideFormat === "suspension" && isMopedStyle) score += 4;
      if (answers.rideFormat === "output") score += power * 3.8 + torque * 0.07;
      if (answers.rideFormat === "either") score += value * 0.6;

      if (answers.terrain === "paved") score += value * 1.2 + (isMopedStyle ? 0 : 3);
      if (answers.terrain === "hills") score += power * 2.4 + torque * 0.05;
      if (answers.terrain === "rough") score += comfort * 2.4 + (model.fullSuspension ? 8 : -6);

      if (targetRange <= minRange) score += 12;
      else score += 4;
      if (targetRange >= 60) score += range * 1.8 + minRange * 0.1;

      score += Math.min(8, Math.max(0, (payload - answers.loadLb) / 20));
      score += value * 0.55;
      score += numeric(model.catalogPriority) * 0.08;
      return score;
    }

    function rankModels(answers) {
      var maxBudget = budgetCeiling(answers.budget);
      var targetRange = distanceTarget(answers.distance);
      var candidates = availableLaneModels(answers).filter(function (model) {
        var payload = numeric(model.payloadLb);
        return model.dataComplete === true && payload > 0 && numeric(model.rangeMax) >= targetRange && answers.loadLb <= payload;
      });
      var scored = candidates.map(function (model) {
        return {
          model: model,
          score: scoreModel(model, answers, targetRange),
          budgetDelta: Number.isFinite(maxBudget) ? Math.max(0, numeric(model.price) - maxBudget) : 0,
          rangeGap: Math.max(0, targetRange - numeric(model.rangeMax)),
          rangeFit: targetRange <= numeric(model.rangeMin) ? "strong" : "reserve",
          targetRange: targetRange
        };
      }).sort(function (a, b) {
        if (b.score !== a.score) return b.score - a.score;
        return numeric(a.model.price) - numeric(b.model.price);
      });

      var withinBudget = Number.isFinite(maxBudget) ? scored.filter(function (entry) {
        return numeric(entry.model.price) <= maxBudget;
      }) : scored;
      var overBudget = Number.isFinite(maxBudget) ? scored.filter(function (entry) {
        return numeric(entry.model.price) > maxBudget;
      }).sort(function (a, b) {
        if (a.budgetDelta !== b.budgetDelta) return a.budgetDelta - b.budgetDelta;
        return b.score - a.score;
      }) : [];
      var ranked = withinBudget.length ? withinBudget.concat(overBudget) : (overBudget.length ? overBudget : scored);

      ranked.forEach(function (entry) {
        var budgetCaution = Number.isFinite(maxBudget) && entry.budgetDelta > 0;
        var rangeCaution = entry.rangeFit === "reserve";
        if (budgetCaution && rangeCaution) entry.matchStatus = "budget_and_range_caution";
        else if (budgetCaution) entry.matchStatus = "budget_stretch";
        else if (rangeCaution) entry.matchStatus = "range_caution";
        else entry.matchStatus = "exact";
      });

      return ranked;
    }

    function rangeText(model) {
      if (numeric(model.rangeMin) > 0 && numeric(model.rangeMax) > 0) return model.rangeMin + "–" + model.rangeMax + " mi listed range";
      if (numeric(model.rangeMax) > 0) return "up to " + model.rangeMax + " mi listed range";
      return "range details on the product page";
    }

    function payloadText(model) {
      return numeric(model.payloadLb) > 0 ? model.payloadLb + " lb maximum payload" : "payload details on the product page";
    }

    function torqueText(model) {
      return numeric(model.torqueNm) > 0 ? model.torqueNm + " Nm torque" : "torque details on the product page";
    }

    function rideReason(model, answers) {
      if (answers.rideFormat === "upright") return "Ride format: this upright, pedal-friendly layout matched your preference.";
      if (answers.rideFormat === "suspension") return model.fullSuspension ? "Ride format: full suspension matched the compact, smoother-riding format you chose." : "Ride format: this is the closest current option after the route, trip, and load checks.";
      if (answers.rideFormat === "output" && numeric(model.torqueNm) > 0) return "Ride format: " + torqueText(model) + " supported the strongest verified output match after the route, trip, and load checks.";
      if (answers.rideFormat === "output") return "Ride format: this was the strongest available match after the route, trip, and load checks.";
      return "Ride format: you left the style open, so trip demands, payload, and price decided the order.";
    }

    function setText(selector, value) {
      var element = root.querySelector(selector);
      if (element) element.textContent = value == null ? "" : String(value);
    }

    function formatMoney(value) {
      var amount = numeric(value);
      return amount.toLocaleString("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: Number.isInteger(amount) ? 0 : 2,
        maximumFractionDigits: 2
      });
    }

    function displayedLoad(answers) {
      if (state.unit === "metric") return Math.round(answers.loadLb / 2.2046226218) + " kg";
      return answers.loadLb + " lb";
    }

    function routeLabel(answers) {
      if (answers.useArea === "private") return "Private-property PPB path";
      if (answers.useArea === "unsure") return "Class 2 path for an unsure route";
      return "Public-access Class 2 path";
    }

    function answerSummary(answers) {
      var rideFormatLabels = {
        upright: "upright utility format",
        suspension: "compact full-suspension format",
        output: "strongest response in the route lane",
        either: "open format"
      };
      var terrainLabels = {
        paved: "mostly paved or packed",
        hills: "frequent or steep hills",
        rough: "rough or mixed"
      };
      var distanceLabels = {
        "under-20": "under 20 mi",
        "20-40": "20–40 mi",
        "40-60": "40–60 mi",
        "60-plus": "60+ mi"
      };
      return routeLabel(answers) + " · " + rideFormatLabels[answers.rideFormat] + " · " + terrainLabels[answers.terrain] + " · " + distanceLabels[answers.distance] + " round trip · " + displayedLoad(answers) + " total load";
    }

    function renderPrice(model) {
      var priceElement = root.querySelector("[data-result-price]");
      if (!priceElement) return;
      priceElement.textContent = model.priceText || formatMoney(model.price);
      if (model.comparePriceText) {
        var comparison = document.createElement("del");
        comparison.textContent = model.comparePriceText;
        priceElement.appendChild(comparison);
      }
    }

    function alternativeComparison(entry, primary) {
      var model = entry.model;
      var details = [rangeText(model), payloadText(model)];
      var priceDifference = numeric(model.price) - numeric(primary.price);
      if (priceDifference < 0) details.push(formatMoney(Math.abs(priceDifference)) + " less than the top match");
      else if (priceDifference > 0) details.push(formatMoney(priceDifference) + " more than the top match");
      else details.push("same current price as the top match");
      return details.join(" · ");
    }

    function renderAlternatives(ranked) {
      if (!alternatives || !alternativesSection) return;
      alternatives.textContent = "";
      var alternates = ranked.slice(1, 3);
      alternativesSection.hidden = alternates.length === 0;
      alternativesSection.open = true;
      if (alternativeCount) alternativeCount.textContent = String(alternates.length);
      alternates.forEach(function (entry, index) {
        var model = entry.model;
        var article = document.createElement("article");
        var media = document.createElement("div");
        var copy = document.createElement("div");
        var title = document.createElement("h4");
        var description = document.createElement("p");
        var price = document.createElement("strong");
        var link = document.createElement("a");
        article.className = "arf-alt";
        media.className = "arf-alt__media";
        copy.className = "arf-alt__copy";
        if (model.image) {
          var image = document.createElement("img");
          image.src = model.image;
          image.alt = model.imageAlt || model.title;
          image.width = numeric(model.imageWidth) || 900;
          image.height = numeric(model.imageHeight) || 600;
          image.loading = "lazy";
          image.decoding = "async";
          media.appendChild(image);
        }
        title.textContent = model.title + (model.subtitle ? " " + model.subtitle : "");
        description.textContent = alternativeComparison(entry, ranked[0].model);
        price.textContent = model.priceText || formatMoney(model.price);
        link.href = model.url;
        link.textContent = "View " + model.title;
        link.dataset.modelHandle = model.handle || model.id;
        link.dataset.modelId = model.id || model.handle;
        link.dataset.resultPlacement = "alternative_" + String(index + 1);
        copy.appendChild(title);
        copy.appendChild(description);
        article.appendChild(media);
        article.appendChild(copy);
        article.appendChild(price);
        article.appendChild(link);
        alternatives.appendChild(article);
      });
    }

    function renderHandoff(classification) {
      var handoff = root.querySelector("[data-handoff]");
      if (handoff) handoff.hidden = selectedValue("riderAge") !== "18-plus";
      var handoffLink = root.querySelector("[data-handoff-link]");
      if (!handoffLink) return;
      if (classification === "ppb") {
        setText("[data-handoff-title]", "Need a public-road or shared-path option?");
        setText("[data-handoff-copy]", "Return to current Class 2 e-bike configurations and confirm your route rules before riding.");
        handoffLink.href = links.classTwoCollection || "/collections/bikes";
        handoffLink.textContent = "Shop Class 2 e-bikes";
        handoffLink.dataset.targetLane = "class2";
      } else {
        setText("[data-handoff-title]", "Riding only on private property or off-road?");
        setText("[data-handoff-copy]", "The performance guide separates high-output PPBs from Class 2 e-bike configurations.");
        handoffLink.href = links.fastest || "/pages/fastest-ariel-rider-bikes";
        handoffLink.textContent = "Compare the PPB performance path";
        handoffLink.dataset.targetLane = "ppb";
      }
    }

    function renderCatalogReview(answers) {
      if (!catalogReview) return;
      var classification = classificationFor(answers);
      var incompleteCount = availableLaneModels(answers).filter(function (model) {
        return model.dataComplete !== true;
      }).length;
      var missingRecordCount = catalogReviewEntries.filter(function (entry) {
        return entry && entry.classification === classification;
      }).length;
      var reviewCount = incompleteCount + missingRecordCount;
      catalogReview.hidden = reviewCount === 0;
      if (!reviewCount || !catalogReviewCopy) return;
      catalogReviewCopy.textContent = reviewCount === 1
        ? "One available configuration needs a catalog review before it can be used for an automatic recommendation."
        : reviewCount + " available configurations need catalog review before they can be used for automatic recommendations.";
    }

    function matchStatusLabel(matchStatus) {
      return matchStatus === "exact" ? "Your best match" : "Closest current match";
    }

    function showNoMatch(answers) {
      var classification = classificationFor(answers);
      var laneLabel = classification === "ppb" ? "PPB private-property/off-road model" : "Class 2 e-bike configuration";
      var payloadRatedModels = availableLaneModels(answers).filter(function (model) {
        return numeric(model.payloadLb) > 0;
      });
      var payloadBlocked = payloadRatedModels.length > 0 && payloadRatedModels.every(function (model) {
        return answers.loadLb > numeric(model.payloadLb);
      });
      var targetRange = distanceTarget(answers.distance);
      var rangeRatedModels = availableLaneModels(answers).filter(function (model) {
        return numeric(model.rangeMax) > 0 && answers.loadLb <= numeric(model.payloadLb);
      });
      var rangeBlocked = rangeRatedModels.length > 0 && rangeRatedModels.every(function (model) {
        return targetRange > numeric(model.rangeMax);
      });

      root.dataset.resultClassification = classification;
      results.dataset.matchStatus = "no_match";
      delete results.dataset.modelHandle;
      delete results.dataset.modelId;
      noMatch.hidden = false;
      primaryResult.hidden = true;
      alternativesSection.hidden = true;
      if (finalCta) finalCta.hidden = true;
      if (copyButton) copyButton.hidden = true;
      setText("[data-result-kicker]", "Fit check needed");
      setText("[data-result-heading]", "We need one more fit check.");
      setText("[data-result-summary]", answerSummary(answers));
      if (payloadBlocked) {
        if (noMatchTitle) noMatchTitle.textContent = "No current model clears a " + displayedLoad(answers) + " load.";
        setText("[data-no-match-copy]", "We will not recommend a " + laneLabel + " below its published payload rating. Change the load only if the entered total is incorrect, or ask support to review the fit.");
      } else if (rangeBlocked) {
        if (noMatchTitle) noMatchTitle.textContent = "No current model clears this trip plan with verified range data.";
        setText("[data-no-match-copy]", "The planning distance is above the published maximum for every remaining " + laneLabel + ". Shorten the trip only if that reflects your real use, or ask support to review charging and range needs.");
      } else {
        if (noMatchTitle) noMatchTitle.textContent = "No current model clears every hard check.";
        setText("[data-no-match-copy]", "No available " + laneLabel + " has enough verified data to recommend automatically. Ask support to review current availability, payload, and configuration.");
      }
      renderCatalogReview(answers);
      renderHandoff(classification);
    }

    function renderResult(ranked, answers) {
      var entry = ranked[0];
      var model = entry.model;
      var classification = model.classification;
      var cta = root.querySelector("[data-result-cta]");
      var reasons = root.querySelector("[data-result-reasons]");
      var maxBudget = budgetCeiling(answers.budget);
      var payloadHeadroom = Math.max(0, numeric(model.payloadLb) - answers.loadLb);
      var isCaution = entry.matchStatus !== "exact";
      var hasCloseMatch = ranked[1] && Math.abs(entry.score - ranked[1].score) <= 4;

      root.dataset.resultClassification = classification;
      results.dataset.matchStatus = entry.matchStatus;
      results.dataset.modelHandle = model.handle || model.id;
      results.dataset.modelId = model.id || model.handle;
      noMatch.hidden = true;
      primaryResult.hidden = false;
      if (copyButton) copyButton.hidden = false;
      setText("[data-result-kicker]", matchStatusLabel(entry.matchStatus));
      setText("[data-result-heading]", hasCloseMatch ? "Two strong options fit your answers." : (isCaution ? "Closest current match." : "Your match is ready."));
      setText("[data-result-summary]", answerSummary(answers));
      setText("[data-result-badge]", model.classLabel);
      setText("[data-result-availability]", model.availabilityLabel || "Available");
      setText("[data-result-title]", model.title + (model.subtitle ? " " + model.subtitle : ""));
      setText("[data-result-blurb]", model.blurb || "This model leads after route, payload, ride, and budget checks.");
      setText("[data-spec-range]", rangeText(model));
      setText("[data-spec-payload]", payloadText(model));
      setText("[data-spec-torque]", torqueText(model));
      setText("[data-spec-speed]", model.topSpeed || (classification === "class2" ? "20 mph Class 2 default" : "See product page"));
      setText("[data-result-boundary]", classification === "ppb" ? "PPB result: operators must be 18 or older, including when speed-limited. Private-property or closed-course use only where permitted, with no public-road, bike-lane, bike-path, or sidewalk use." : "E-bike operators must be 16 or older. Class 2 shopping path: 20 mph motor-assist default. Confirm state and local rules, route access, and the shipped configuration before riding.");

      if (resultImage) {
        if (model.image) {
          resultImage.src = model.image;
          resultImage.alt = model.imageAlt || model.title;
        } else {
          if (resultImagePlaceholder) resultImage.src = resultImagePlaceholder;
          else resultImage.removeAttribute("src");
          resultImage.alt = "";
        }
        resultImage.width = numeric(model.imageWidth) || 900;
        resultImage.height = numeric(model.imageHeight) || 600;
        resultImage.loading = "eager";
        resultImage.fetchPriority = "high";
      }

      renderPrice(model);
      if (reasons) {
        reasons.textContent = "";
        var reasonList = [rideReason(model, answers)];
        if (entry.rangeFit === "strong") {
          reasonList.push("Trip and load: the " + entry.targetRange + "-mile planning distance stays below the lower end of the published estimate, and the payload rating leaves about " + Math.round(payloadHeadroom) + " lb of headroom.");
        } else {
          reasonList.push("Trip and load: the " + entry.targetRange + "-mile planning distance falls within the published estimate, with about " + Math.round(payloadHeadroom) + " lb of payload headroom. Plan extra battery reserve for hills, speed, weather, and heavier loads.");
        }
        if (Number.isFinite(maxBudget) && entry.budgetDelta > 0) {
          reasonList.push("Price stretch: the current price is " + formatMoney(entry.budgetDelta) + " above your selected ceiling because no eligible model under that price cleared the route, trip, and load checks.");
        } else if (Number.isFinite(maxBudget)) {
          reasonList.push("Price fit: the current " + (model.priceText || formatMoney(model.price)) + " price stays within your " + formatMoney(maxBudget) + " ceiling.");
        } else {
          reasonList.push("Price check: the current price is " + (model.priceText || formatMoney(model.price)) + " before options, taxes, and any delivery charges.");
        }
        reasonList.forEach(function (reason) {
          var item = document.createElement("li");
          item.textContent = reason;
          reasons.appendChild(item);
        });
      }

      if (cta) {
        cta.href = model.url;
        cta.textContent = "View " + model.title + " details";
        cta.className = "arf-button " + (classification === "ppb" ? "arf-button--ppb" : "arf-button--class2");
        cta.dataset.modelHandle = model.handle || model.id;
        cta.dataset.modelId = model.id || model.handle;
        cta.dataset.resultPlacement = "primary";
      }
      if (finalCta && finalResultCta) {
        finalCta.hidden = false;
        setText("[data-final-title]", "Ready to see " + model.title + "?");
        finalResultCta.href = model.url;
        finalResultCta.textContent = "View " + model.title + " details";
        finalResultCta.className = "arf-button " + (classification === "ppb" ? "arf-button--ppb" : "arf-button--class2");
        finalResultCta.dataset.modelHandle = model.handle || model.id;
        finalResultCta.dataset.modelId = model.id || model.handle;
        finalResultCta.dataset.resultPlacement = "final";
      }
      renderAlternatives(ranked);
      renderCatalogReview(answers);
      renderHandoff(classification);
    }

    function revealResults(shouldScroll) {
      if (!validateAge()) {
        setStep(1, true);
        validateAge();
        return;
      }
      var answers = readAnswers();
      var ranked = rankModels(answers);
      var classification = classificationFor(answers);
      var matchStatus = ranked[0] ? ranked[0].matchStatus : "no_match";
      state.answers = answers;
      state.ranked = ranked;

      runTransition(function () {
        if (ranked.length) renderResult(ranked, answers);
        else showNoMatch(answers);
        results.hidden = false;
        root.classList.add("is-complete");
      }, "is-revealing");
      announce("");
      if (resultStatus) resultStatus.textContent = ranked.length ? ranked[0].model.title + " recommendation ready." : "No automatic recommendation is available. A fit check is needed.";
      if (shouldScroll !== false) scrollToElement(results);
      results.focus({ preventScroll: true });
      root.dispatchEvent(new CustomEvent("ar:finder-result", {
        detail: {
          classification: classification,
          model: ranked[0] ? ranked[0].model.handle : null,
          matchStatus: matchStatus
        }
      }));
    }

    function editAnswers() {
      results.hidden = true;
      if (finalCta) finalCta.hidden = true;
      if (resultStatus) resultStatus.textContent = "";
      root.classList.remove("is-complete");
      root.dataset.resultClassification = "";
      setStep(1, true);
    }

    function resetFinder() {
      form.reset();
      state.reached = 1;
      state.loadLb = 0;
      state.ranked = [];
      state.answers = null;
      results.hidden = true;
      if (finalCta) finalCta.hidden = true;
      if (resultStatus) resultStatus.textContent = "";
      root.classList.remove("is-complete");
      root.dataset.resultClassification = "";
      setActiveLane("");
      setUnit(settings.defaultUnit === "metric" ? "metric" : "us", false);
      setStep(1, true);
    }

    function shareResult() {
      if (!state.ranked.length || !copyButton) return;
      var model = state.ranked[0].model;
      var url = new URL(model.url, window.location.origin).toString();
      var originalText = "Save or share result";
      var showSaved = function (message) {
        copyButton.textContent = message;
        if (resultStatus) resultStatus.textContent = message + ".";
        window.setTimeout(function () { copyButton.textContent = originalText; }, 1800);
      };

      if (navigator.share) {
        navigator.share({
          title: model.title + " · Ariel Rider",
          text: "My Ariel Rider bike finder result",
          url: url
        }).then(function () { showSaved("Result shared"); }).catch(function () {});
        return;
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(function () { showSaved("Product link copied"); }).catch(function () {
          window.prompt("Copy this product link:", url);
        });
      } else {
        window.prompt("Copy this product link:", url);
      }
    }

    nextButton.addEventListener("click", function () {
      if (!validateStep()) return;
      if (state.step < steps.length) {
        setStep(state.step + 1, true);
      } else {
        revealResults(true);
      }
    });

    backButton.addEventListener("click", function () {
      setStep(state.step - 1, true);
    });

    resetButton.addEventListener("click", resetFinder);

    form.addEventListener("submit", function (event) {
      event.preventDefault();
      nextButton.click();
    });

    form.addEventListener("change", function (event) {
      if (!event.target.matches("input[type='radio']")) return;
      results.hidden = true;
      if (finalCta) finalCta.hidden = true;
      if (resultStatus) resultStatus.textContent = "";
      root.classList.remove("is-complete");
      root.dataset.resultClassification = "";
      state.ranked = [];
      state.answers = null;
      announce("");
      if (event.target.name === "useArea") setActiveLane(event.target.value);
      if (event.target.name === "riderAge" || event.target.name === "useArea") {
        state.reached = 1;
        setStep(1, false);
        validateAge();
      }
    });

    loadInput.addEventListener("input", updateLoadFromInput);

    unitButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        setUnit(button.dataset.unit, true);
      });
    });

    stepButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        if (!button.disabled) setStep(Number(button.dataset.jumpStep), true);
      });
    });

    editButtons.forEach(function (button) {
      button.addEventListener("click", editAnswers);
    });

    if (copyButton) copyButton.addEventListener("click", shareResult);

    root.addEventListener("click", function (event) {
      var productLink = event.target.closest("[data-model-handle]");
      if (!productLink) return;
      root.dispatchEvent(new CustomEvent("ar:finder-product-click", {
        detail: {
          handle: productLink.dataset.modelHandle,
          placement: productLink.dataset.resultPlacement || "unknown"
        }
      }));
    });

    setUnit(state.unit, false);
    setActiveLane(selectedValue("useArea"));
    setStep(1, false);
  }

  function initAll(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll("[data-arf]"), initFinder);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { initAll(document); }, { once: true });
  } else {
    initAll(document);
  }

  document.addEventListener("shopify:section:load", function (event) { initAll(event.target); });
})();
